<template>
    <div class="container-fluid">
      <div class="form-group row justify-content-center" v-if="children.length>0">
        <div class="d-flex flex-row justify-content-center">
          <b-form-group id="input-group-2">
            <b-form-select v-model="childSelected" :options="children" v-on:change="limitSon()"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <span v-if="selectedStudent && selectedStudent.idSon !== null ">
        <div class="d-flex flex-row justify-content-center mt-1">
          <div class="card-body d-flex flex-row justify-content-center py-0">
            <div class="col-12 col-sm-9 col-lg-5 justify-content-center">
                <div class="d-flex flex-row justify-content-center">
                  <div>
                    <img :src="`${selectedStudent.pathAvatar}?tr=w-130`"
                    @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                    class="rounded-circle img-thumbnail" />
                  </div>
                  <div class="pl-3 pt-3">
                    <h5><b>GRADO: </b>{{ selectedStudent.grade }}</h5>
                    <h5><b>SALDO: </b>{{ currencyFormat(selectedStudent.balance) }}</h5>
                    <h5><b>Combo/Brunchs: </b>{{ selectedStudent.combos }}</h5>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-center" v-if="childSelected">
        <div class="card col-12 col-lg-8 mt-2">
          <div class="card-body">
            <div>
              <h5>Valor máximo de compras</h5>
              <p class="card-text">Limitar el valor máximo de las compras en el día. Si alcanza el valor máximo del día, el estudiante no podrá realizar más compras hasta el día siguiente.</p>
              <div class="mx-2">
                  <b-form-group id="input-group-1" label="Valor máximo por día:" label-for="input-1">
                    <b-input-group style="height: 35px;">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
                      </div>
                      <money v-model="valueMax" v-bind="money" class="form-input col-10 col-sm-6 col-md-3"></money>
                    </b-input-group>
                  </b-form-group>
                </div>
                <b-col cols="12" sm="12" md="12">
                  <div style="color: indianred">{{ this.msgValueToBuyLimitValidation }}</div>
                </b-col>
            </div>
            <hr style="margin: 2rem 0px !important;" />
            <div v-if="formCredit">
              <span>
               <h5>Crédito</h5>
               <p class="card-text">Permite realizar compras cuando el saldo recargado no es suficiente, el crédito utilizado se descontará en la siguiente recarga.<br>Si la restricción de valor máximo por día está activada, el crédito no altera dicho valor, solo completará la compra.</p>
              </span>
              <div class="mt-3 d-flex flex-nowrap">
                <div class="mr-2 my-auto">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" :checked="activeCredit" class="custom-control-input"
                     id="credit-sons" @change="updateCredit(!activeCredit)">
                    <label class="custom-control-label" for="credit-sons">Habilitar crédito para realizar compras en cafetería.</label>
                    <div>
                      <h6><small class="text-secondary">El crédito otrogado por la institución es de {{ currencyFormat(formCredit.credit) }}.</small></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr style="margin: 2rem 0px !important;" />
            <div>
              <h5>Productos disponibles</h5>
              <p class="card-text">Seleccione los productos que desea que se encuentren habilitados en el momento de la compra. Los productos seleccionados serán los únicos que el estudiante podrá comprar.*</p>
                <b-row>
                  <b-col class="m-1 m-sm-3">
                    <b-table v-if="filteredProducts.length > 0" striped hover :fields="columnsProduct" :items="filteredProducts" head-variant="light" responsive>
                      <template #cell(state)="filteredProducts">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top" class="my-auto">
                            <template #title>
                              <span>{{ disabledProducts.includes(filteredProducts.item.id) ? 'Deshabilitado' : 'Habilitado' }}</span>
                            </template>
                            <i v-if="!disabledProducts.includes(filteredProducts.item.id)" class="fa fa-check-circle text-success" style="font-size: 1.5rem;" />
                            <i v-if="disabledProducts.includes(filteredProducts.item.id)" class="fa fa-close text-danger" style="font-size: 1.5rem;" />
                          </a-tooltip>
                        </div>
                      </template>
                      <template #cell(actions)="filteredProducts">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top">
                            <template #title>
                              <span>Ver información</span>
                            </template>
                            <button type="button" @click="() => openModal(filteredProducts.item)" class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <a-tooltip placement="top" class="my-auto">
                            <div class="custom-control custom-switch">
                              <input type="checkbox"
                                    :checked="!disabledProducts.includes(filteredProducts.item.id)"
                                    class="custom-control-input"
                                    :id="filteredProducts.item.id"
                                    @change="addProduct(filteredProducts.item.id)">
                              <label class="custom-control-label" :for="filteredProducts.item.id"></label>
                            </div>
                          </a-tooltip>
                        </div>
                      </template>
                    </b-table>
                    <empty-table v-else/>
                    <b-row>
                      <b-col>
                        <b-pagination
                          v-model="pagination.currentPage"
                          :total-rows="pagination.rows"
                          :per-page="pagination.perPage"
                          @input="getProducts()"
                          aria-controls="my-table"
                        ></b-pagination>
                      </b-col>
                      <b-col class="text-right">
                        {{ pagination.rows }} resultados
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              <b-row align-h="start">
                <b-col xl="5" class="my-auto">
                  <b-button variant="light" class="btn-sm mr-2" @click="removeLimit(selectedStudent.idSon)" v-if="( (this.selectedStudent ) && (this.selectedStudent.buyLimit > 0 || this.selectedStudent.products.length > 0))">Restablecer</b-button>
                  <b-button variant="primary" @click="createLimit(selectedStudent.idSon)" :disabled="chargeActiveButton">
                    {{ ((this.selectedStudent) && (this.selectedStudent.buyLimit > 0 || this.selectedStudent.products.length > 0)) ? 'Actualizar': 'Guardar' }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        </div>
        <b-modal id="see-product" no-enforce-focus ref="modal" title="Producto" hide-footer size="lg">
          <b-row class="m-3">
            <b-col>
              <product :product="modalProduct"/>
            </b-col>
          </b-row>
          <span class="d-flex flex-row float-right mr-4 mb-3 mt-0 align-text-bottom">
            <b-button @click="$bvModal.hide('see-product')" variant="light" size="sm">Cerrar</b-button>
          </span>
        </b-modal>
      </span>
      <empty-table class="mt-3" v-else/>
    </div>
  </template>

<script>
import { Money } from 'v-money'
import { currencyFormatPesos, showErrorMessage, consts } from '@/services/utilities'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import emptyTable from '@/components/custom/cardEmptyList'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import product from '../../../components/custom/product'
import { ToastFire } from '@/services/utilities/swal'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  name: 'parentalControl',
  components: { Money, emptyTable, product },
  data() {
    return {
      valueMax: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false,
      },
      disabledProducts: [],
      products: [],
      modalProduct: {},
      selectedStudent: {
        buyLimit: 0,
        products: [],
        idSon: null,
        fullName: '',
        grade: '',
        balance: 0,
        pathAvatar: '',
        combos: 0,
      },
      children: [],
      isDropdownOpen: false,
      columnsProduct: [
        { label: 'Producto', key: 'name' },
        { label: 'Precio', key: 'cost' },
        { key: 'state', label: 'Estado', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      childSelected: null,
      msgValueToBuyLimitValidation: '',
      chargeActiveButton: true,
      formCredit: {
        id: 0,
        key: '',
        userParam: [],
        credit: 0,
      },
      activeCredit: false,
      consts: consts,
    }
  },
  created() {
    apiClient.get(`/users/check-children/${this.user.id}`).then(response => {
      if (response.data.length > 0) {
        this.children = response.data.map(x => {
          return {
            value: x.idChild,
            text: x.fullName,
          }
        })
      }
      this.children.unshift({ value: null, text: 'Seleccione el estudiante', disabled: true })
    }).catch(e => {
      Toast.fire({
        icon: 'warning',
        title: showErrorMessage(e),
      })
    })
  },
  methods: {
    currencyFormat(money) {
      return currencyFormatPesos(money)
    },
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    openModal(product) {
      this.modalProduct = product
      this.$bvModal.show('see-product')
    },
    getProducts() {
      const sentParams = {
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage - 1,
        isEvent: false,
      }
      apiClient2.get('sales/products', { params: sentParams }).then(response => {
        this.products = [...response.data.data.rows]
        this.pagination.rows = response.data.data.count ? response.data.data.count : 0
      }).catch(e => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(e),
        })
      })
    },
    addProduct(id) {
      const index = this.disabledProducts.indexOf(id)
      if (index >= 0) {
        this.disabledProducts.splice(index, 1)
      } else {
        this.disabledProducts.push(id)
      }
    },
    limitSon() {
      this.activeCredit = false
      this.getProducts()
      this.getCreditChildren(this.childSelected)
      apiClient2.get(`sales/controlParental/${this.childSelected}`).then(response => {
        this.selectedStudent = {
          buyLimit: response.data.data.buyLimit || 0,
          products: response.data.data.products || [],
          idSon: response.data.data.idSon,
          fullName: response.data.data.fullName,
          grade: response.data.data.grade || 'Sin asignar',
          balance: response.data.data.balance || 0,
          pathAvatar: response.data.data.pathAvatar,
          combos: response.data.data.combos,
        }
        this.valueMax = (this.selectedStudent && this.selectedStudent.buyLimit) ? this.selectedStudent.buyLimit : 0
        this.disabledProducts = (this.selectedStudent && this.selectedStudent.products) ? [...this.selectedStudent.products] : []
      }).catch(e => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(e),
        })
      })
    },
    createLimit(id) {
      if ((this.selectedStudent && (this.selectedStudent.buyLimit > 0 || this.selectedStudent.products.length > 0))) {
        apiClient2.patch(`sales/controlParental/${id}`, { buyLimit: this.valueMax, products: this.disabledProducts }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Limitaciones actualizadas exitosamente',
          })
        }).catch(e => {
          Toast.fire({
            icon: 'warning',
            title: showErrorMessage(e),
          })
        })
      } else {
        apiClient2.post(`sales/controlParental/${id}`, { buyLimit: this.valueMax, products: this.disabledProducts }).then(response => {
          this.selectedStudent.buyLimit = (response.data.data && response.data.data.buyLimit) ? response.data.data.buyLimit : 0
          this.selectedStudent.products = (response.data.data && response.data.data.products) ? response.data.data.products : []
          Toast.fire({
            icon: 'success',
            title: 'Limitaciones establecidas exitosamente',
          })
        }).catch(e => {
          Toast.fire({
            icon: 'warning',
            title: showErrorMessage(e),
          })
        })
      }
    },
    removeLimit(id) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Desea eliminar el resticiones ha ' + this.selectedStudent.fullName + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`sales/controlParental/${id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: `${response.data.message}`,
            })
            this.selectedStudent.buyLimit = 0
            this.selectedStudent.products = []
            this.valueMax = 0
            this.disabledProducts = []
          }).catch(error => {
            console.log(error)
            Toast.fire({
              icon: 'warning',
              title: 'Ooops ocurrió un error' + showErrorMessage(error),
            })
          })
        }
      })
    },
    getCreditChildren(id) {
      apiClient2.get(`/userSpecificParam/user/${id}/param/${consts.ID_PARAM.CREDIT}`).then((response) => {
        this.formCredit = response.data.data[0]
        this.activeCredit = (this.formCredit && this.formCredit.userParam.length > 0) ? this.formCredit.userParam[0].userSpecificParam.active : false
      }).catch((error) => {
        console.log('error', error)
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(error),
        })
      })
    },
    updateCredit(active) {
      const dataCredit = [{
        ...(this.formCredit.userParam.length > 0 && this.formCredit.userParam[0].userSpecificParam.id && { id: this.formCredit.userParam[0].userSpecificParam.id }),
        idSpecificParam: this.formCredit.id,
        active,
      }]
      apiClient2.patch(`userSpecificParam/${this.selectedStudent.idSon}`, { sentParams: dataCredit }).then((response) => {
        this.activeCredit = active
        this.formCredit.userParam[0] = {
          id: response.data.data[0].idUser,
          userSpecificParam: {
            id: response.data.data[0].id,
            idSpecificParam: response.data.data[0].idSpecificParam,
            active: response.data.data[0].active,
          },
        }
        ToastFire('success', (this.formCredit.userParam.length > 0) ? `El crédito ${active ? 'ha sido activado' : 'ha sido desactivado'} con éxito` : 'El crédito ha sido activado con éxito.')
      }).catch(error => {
        ToastFire('warning', showErrorMessage(error))
      })
    },
  },
  watch: {
    valueMax: function(val) {
      if (val < 0 || val === '' || isNaN(val)) {
        this.msgValueToBuyLimitValidation = 'El valor máximo por día debe ser mayor o igual a cero (0).'
        return
      }
      if (val > 1000000 || val === '' || isNaN(val)) {
        this.msgValueToBuyLimitValidation = "El valor máximo por día debe ser menor o igual a un millón (1'000.000))."
        return
      }
      this.msgValueToBuyLimitValidation = ''
      this.chargeActiveButton = false
    },
    disabledProducts: function(disabled) {
      if (disabled.length > 0) { this.chargeActiveButton = false }
      if (disabled.length === 0 && this.valueMax === 0) { this.chargeActiveButton = true }
    },
  },
  computed: {
    ...mapState(['user']),
    filteredProducts: function() {
      return this.products.filter((product) => {
        return this.slugify(product.name.trim().toLowerCase())
      })
    },
  },
}
</script>
